import { delay } from 'src/app/shared/utils/delay';

type PollUntilOptions = { interval?: number; timeout?: number; enabled?: boolean };
export async function pollUntil<T>(fn: () => Promise<T | undefined>, options: PollUntilOptions = {}) {
	const { interval = 1000, timeout = 10000, enabled = true } = options;

	if (!enabled) return;

	let stopped = false;

	const polling = async () => {
		while (!stopped) {
			// eslint-disable-next-line no-await-in-loop
			const [fnResult] = await Promise.allSettled([fn(), delay(interval)]);

			if (fnResult.status === 'fulfilled' && fnResult.value !== undefined) {
				stopped = true;
				return fnResult.value;
			}
		}
		return undefined;
	};

	await Promise.race([
		polling(),
		// eslint-disable-next-line promise/always-return
		delay(timeout).then(() => {
			stopped = true;
		}),
	]);
}
